import { FacadeService } from "../../service/facade.service";
import { tap } from "rxjs/operators";

export abstract class ProductsMange {
  categories = [];
  products = [];
  currentCatogery;

  constructor(public _facadeService: FacadeService) {}

  getAllCatogeries() {
    this._facadeService.Product.categories
      .pipe(
        tap(res => {
          const newData: Array<any> = [];
          for (const product of res.data) {
            const newObj = { ...product, show: false };
            newData.push(newObj);
          }
          res.data = newData;
        })
      )
      .subscribe(res => {
        this.categories = res.data;
      });
  }

  abstract getProducts();

  /**
   * set pagiantion data and
   * @param res success request body
   */
  setProductRespone(res: any) {
    let newData: Array<any> = [];

    for (let data of res.data.data) {
      let newObj = { ...data, show: false, loading: true };
      newData.push(newObj);
    }

    this.products = newData;
  }

  loaded(index: number) {
    this.products[index].loading = false;
  }

  setCategory(id: number) {
    this.currentCatogery = id;
  }
}
